import React from 'react';
import { MARGIN_MODE_COMBINED, MARGIN_MODE_RECOGNISED } from '../../hooks/useMarginViewMode';

const OPTIONS = [
  {
    key: MARGIN_MODE_RECOGNISED,
    label: 'Shipped',
    shortLabel: 'Shipped',
    hint: 'Loads that shipped — picked up, on route, delivered or invoiced',
    dot: 'bg-emerald-500',
  },
  {
    key: MARGIN_MODE_COMBINED,
    label: 'Shipped + Pipeline',
    shortLabel: '+ Pipeline',
    hint: 'Adds booked loads scheduled to be picked up inside this period',
    dot: 'bg-amber-500',
  },
];

/** Segmented control that flips every margin figure between the two views. */
export const MarginViewToggle = ({ mode, setMode, className = '', short = false }) => (
  <div
    className={`inline-flex items-center rounded-lg border border-slate-300 bg-white p-0.5 ${className}`}
    role="group"
    aria-label="Margin view"
    data-testid="margin-view-toggle"
  >
    {OPTIONS.map((o) => {
      const on = mode === o.key;
      return (
        <button
          key={o.key}
          type="button"
          onClick={() => setMode(o.key)}
          title={o.hint}
          aria-pressed={on}
          className={'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-medium transition-colors whitespace-nowrap '
            + (on ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100')}
          data-testid={`margin-mode-${o.key}`}
        >
          <span className={`w-1.5 h-1.5 rounded-full ${on ? 'bg-white/80' : o.dot}`} />
          {short ? o.shortLabel : o.label}
        </button>
      );
    })}
  </div>
);

export default MarginViewToggle;
